import React from 'react';
import { Link } from 'react-router-dom'; // Import the Link component from React Router to enable navigation
import './DashboardPage.css'; // Import the CSS file for styling
import doctordummy from '../assets/doctordummy.avif';
import { FaDownload } from 'react-icons/fa'; // Import the download icon from react-icons library

const DashboardPage = () => {
    // Define an array of appointment data
    const appointments = [
        { id: 1, title: 'Appointment 1', description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit.', date: '10:00 AM', status: 'pending', prescriptionPdf: null, reportPdf: null, doctorName: null, doctorDesc: null },
        { id: 2, title: 'Appointment 2', description: 'Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.', date: '11:00 AM', status: 'resolved', prescriptionPdf: 'path/to/prescription.pdf', reportPdf: 'path/to/report.pdf', doctorName: 'Dr. John Doe', doctorDesc: 'Anthrologist' },
        { id: 3, title: 'Appointment 3', description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit.', date: '10:00 AM', status: 'resolved', prescriptionPdf: null, reportPdf: null, doctorName: null, doctorDesc: null },
        { id: 4, title: 'Appointment 4', description: 'Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.', date: '11:00 AM', status: 'resolved', prescriptionPdf: 'path/to/prescription.pdf', reportPdf: 'path/to/report.pdf', doctorName: 'Dr. John Doe', doctorDesc: 'Anthrologist' },
        { id: 5, title: 'Appointment 5', description: 'Lorem ipsum dolor sit amet, consectetur adipiscing elit.', date: '10:00 AM', status: 'resolved', prescriptionPdf: null, reportPdf: null, doctorName: null, doctorDesc: null },
        { id: 6, title: 'Appointment 6', description: 'Sed do eiusmod tempor incididunt ut labore et dolore magna aliqua.', date: '11:00 AM', status: 'resolved', prescriptionPdf: 'path/to/prescription.pdf', reportPdf: 'path/to/report.pdf', doctorName: 'Dr. John Doe', doctorDesc: 'Anthrologist' },
    ];

    return (
        <div className="dashboard-container">
            {appointments.map(appointment => (
                <div key={appointment.id} className={`kiosk-card ${appointment.status === 'pending' ? 'pending' : 'resolved'}`}>
                    <div className="kiosk-card-header">
                        <h3>{appointment.title}</h3>
                        <h4>{appointment.date}
                            <button type="button" className={`status-button ${appointment.status === 'pending' ? 'pending' : 'resolved'}`}>{appointment.status}</button>
                        </h4>
                    </div>
                    <div className="kiosk-card-body">
                        <div className='doctor-img'><img src={doctordummy} alt="Doctor" /></div>
                        <div className='doctor-desc'>
                            {appointment.doctorName !== null ? <><h4>{appointment.doctorName}</h4>
                                <p>{appointment.doctorDesc}</p></>
                                : <p>Not Assigned</p>}
                        </div>
                    </div>
                    <div className='button-wrapper'>
                        <a href={appointment.reportPdf} target="_blank" rel="noopener noreferrer">
                            <button type="button" className='report'>Report <FaDownload /></button>
                        </a>
                        <a href={appointment.prescriptionPdf} target="_blank" rel="noopener noreferrer">
                            <button type="button" className='prescription'>Prescription <FaDownload /></button>
                        </a>


                    </div>
                </div>
            ))}
        </div>
    );
};

export default DashboardPage;
